"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuePointer = void 0;
exports.ValuePointer = require("./pointer");
